.filtersWrapper {
  padding: 16px 16px 8px;
}

.filterSelectButton {
  appearance: none;
  border: none;
  color: inherit;
  background: none;
  padding: 8px 0;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  transition: color 0.2s ease-in-out;

  &:hover,
  &:focus {
    color: var(--color-text-brand-soft);
  }
}

.filterSelectIcon {
  width: 16px;
  height: 16px;
}

.filterOverlay {
  background: var(--color-bg-primary);
  border-radius: 12px;
  box-shadow: var(--dropdown-shadow);
  min-width: 230px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: stretch;
  row-gap: 16px;
  padding: 8px 12px;
  z-index: 1;

  > label {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 15px;
  }

  [data-color-scheme='dark'] & {
    border: 1px solid var(--color-border-primary);
  }
}

.tagsWrapper,
.tagSuggestions {
  margin: 0 16px 8px;
}

.tagsWrapper {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 8px;
}

.tagsList {
  display: flex;
  gap: 4px;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;

  > button {
    flex-shrink: 0;
  }
}

.tagsListShowAll {
  flex-wrap: wrap;
  overflow: visible;
  max-width: none !important;
}

.statusWrapper {
  &:has(.pinnedViewAllButton) :global(.status):has(.pinnedStatusHeader) {
    border-bottom: none;
  }

  article:has(.pinnedViewAllButton) {
    border-bottom: 1px solid var(--color-border-primary);
  }
}

.pinnedViewAllButton {
  background-color: var(--color-bg-primary);
  border-radius: 8px;
  border: 1px solid var(--color-border-primary);
  box-sizing: border-box;
  color: var(--color-text-primary);
  line-height: normal;
  margin: 12px 16px;
  padding: 8px;
  transition: border-color 0.2s ease-in-out;
  width: calc(100% - 32px);

  &:hover,
  &:focus {
    background-color: inherit;
    border-color: var(--color-bg-brand-base-hover);
  }
}

.pinnedStatusHeader {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  gap: 4px;

  > :global(.status__relative-time) {
    grid-column: 2;
    height: auto;
  }

  > :global(.status__display-name) {
    grid-row: span 2;
  }
}
